<template>
  <div class="card" @mouseover="hover = true" @mouseleave="hover = false">
    <div
      @click="sendBack"
      class="image"
      :style="{ 'background-image': `url(${heatmap.image_thumb})` }"
    ></div>
    <div class="bottom">
      <transition name="card-fade">
        <div class="menu" v-if="hover">
          <div class="buttons">
            <div class="analyze" @click="sendBack">View</div>
            <div class="actions">
              <!-- <div class="edit">
                <bg-icon name="fedit"></bg-icon>
              </div> -->
              <div class="delete" @click="sendBackDelete">
                <bg-icon name="fdelete"></bg-icon>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div class="details">
        <div class="title">
          <span>{{ heatmap.title }}</span>
        </div>
        <div class="right-details">
          <!-- <p>Clarity: 8.5</p>
          <p>Readability: 8.5</p> -->
          <p>{{ heatmap.requester.email }}</p>
          <p>{{ getDate() }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BgIcon from "@/components/bg-icon";
import moment from "moment";

export default {
  props: ["heatmap"],
  components: {
    BgIcon,
  },
  data() {
    return {
      hover: false,
      image:
        "https://minio.braingineers.com/brainpeekv2-staging/uploads/prediction/image/13/Schermafbeelding_2021-06-25_om_11.01.23.png?X-Amz-Expires=1800&X-Amz-Date=20210628T080313Z&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=BRAINGINEERS%2F20210628%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-SignedHeaders=host&X-Amz-Signature=b751df9b631d3633a6742aac51f569668d70db8a925e8cf88b6149875cf0d466",
    };
  },
  methods: {
    getDate() {
      return moment(this.heatmap.created_at).format("DD-MM-YYYY");
    },
    sendBack() {
      this.$emit("analyze", this.id);
    },
    sendBackDelete() {
      this.$emit("delete", this.id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
